import React from "react";
import * as MUIcon from '@material-ui/icons';

export function MAKE_OPTIONS_ICON(table) {
    return table.map(row => ({
        label: row.component,
        value: row.id
    }));
}

export const ICON_LIST = [
    { id: "Blank" },
    ...Object.keys(MUIcon)
        .filter(name => {
            const v = MUIcon[name];
            return v != null && typeof v !== 'string' && typeof v !== 'number' && name !== 'default';
        })
        .sort()
        .map(name => ({ id: name, component: React.createElement(MUIcon[name]) })),
];
